import React from "react";
import { Dumbbell, Trophy, Award, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const divisions = [
  {
    icon: <Dumbbell size={48} aria-hidden="true" />,
    title: "Boxing Gym & Fitness",
    description:
      "Train at Bond Boxing in Gaborone, Botswana. Our gym offers boxing training, fitness programmes, personal training and structured coaching for beginners and experienced athletes looking to improve their skills and fitness.",
    features: [
      "Boxing Training Programmes",
      "Gym Membership Packages",
      "Personal Training",
      "Fitness & Conditioning",
    ],
    link: "/gym",
  },
  {
    icon: <Trophy size={48} aria-hidden="true" />,
    title: "Boxing Events",
    description:
      "Experience the excitement of boxing in Botswana. Bond Boxing brings together fighters, supporters and boxing enthusiasts through fight nights, amateur tournaments and competitive boxing events.",
    features: [
      "Boxing Fight Nights",
      "Event Announcements",
      "Past Boxing Events",
      "Tournament Information",
    ],
    link: "/events",
  },
  {
    icon: <Award size={48} aria-hidden="true" />,
    title: "125 Club",
    description:
      "The Bond Boxing 125 Club focuses on developing the next generation of boxing talent through disciplined training, amateur competition and opportunities for young aspiring fighters.",
    features: [
      "Amateur Boxing",
      "Fighter Development",
      "Youth Boxing Opportunities",
      "Competitive Boxing",
    ],
    link: "/amateur",
  },
];

const DivisionsOverview = () => {
  return (
    <section
      id="divisions"
      className="bg-black py-20 md:py-32"
      aria-labelledby="divisions-heading"
    >
      <div className="container mx-auto px-6">

        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            id="divisions-heading"
            className="text-white text-5xl md:text-6xl font-bold mb-6"
          >
            What We Do
          </h2>

          <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto">
            Bond Boxing is a boxing and fitness establishment based in
            Gaborone, Botswana. From professional coaching and fitness
            training to amateur boxing development and exciting fight
            events, we provide opportunities for people to train,
            compete and grow.
          </p>
        </div>

        {/* Divisions Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {divisions.map((division) => (
            <article
              key={division.link}
              className="bg-zinc-950 border border-gray-800 hover:border-red-600 transition-all duration-300 group hover:-translate-y-2"
            >
              <div className="p-8">

                {/* Icon */}
                <div
                  className="w-20 h-20 bg-red-600 flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-transform duration-300"
                  aria-hidden="true"
                >
                  {division.icon}
                </div>

                {/* Title */}
                <h3 className="text-white text-2xl font-bold mb-4 group-hover:text-red-500 transition-colors duration-300">
                  {division.title}
                </h3>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed mb-6">
                  {division.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {division.features.map((feature) => (
                    <li
                      key={feature}
                      className="text-gray-500 text-sm flex items-center gap-2"
                    >
                      <span className="text-red-500" aria-hidden="true">
                        •
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* Navigation Link */}
                <Link
                  to={division.link}
                  className="inline-flex items-center gap-2 text-red-500 hover:text-white font-semibold transition-all duration-300 group-hover:gap-4"
                  aria-label={`Learn more about ${division.title}`}
                >
                  Learn More
                  <ArrowRight size={20} aria-hidden="true" />
                </Link>

              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default DivisionsOverview;